import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { NotificationService } from 'src/app/services/notification.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  isLoggedIn: boolean = false;
  public menu: any;
  unreadMessagesCount: number = 0;
  
  constructor(
    public auth: AuthService,
    public notificationService: NotificationService,
    @Inject(DOCUMENT) public document: Document,
    private location: Location
    ) { }


  ngOnInit(): void {
  this.auth.isAuthenticated$.subscribe(resp => {
      this.isLoggedIn = resp;
    });
    
    this.auth.idTokenClaims$.subscribe({
      next: (r) => {
        if (this.location.path() !== '/registro-exitoso'){
          this.notificationService.startConnection(r?.__raw);
          this.notificationService.loadUnreadMessages();
        }
      }
    });
    
    // Escuchar actualizaciones en tiempo real
    if (this.location.path() !== '/registro-exitoso'){
      this.notificationService.unreadMessages$.subscribe({
        next: count => {
          this.unreadMessagesCount = count;
        },
        error: err => console.error('Error al recibir notificaciones:', err)
      });
    }
  }

  logout() {
    this.auth.logout({ 
      logoutParams: {
        returnTo: this.document.location.origin 
      }
    });
  }
}
